function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.879 10.686 10.807 9 7.879 7.314z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9.001 9.001 0 0 0 0 18A9.001 9.001 0 0 0 9 0m5.624 9.01s0 1.824-.232 2.705a1.41 1.41 0 0 1-.991.99c-.88.232-4.401.232-4.401.232s-3.511 0-4.4-.24a1.41 1.41 0 0 1-.992-.992C3.376 10.835 3.376 9 3.376 9s0-1.825.232-2.705c.13-.482.519-.871.991-1C5.48 5.062 9 5.062 9 5.062s3.52 0 4.4.24c.482.13.862.51.992.992.241.88.232 2.714.232 2.714",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.beea229cb5301486c3be19ab18b90ad5.svg";
export { ForwardRef as ReactComponent };